import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import BaseChannelSerializer from '@square/dashboard-data/serializers/channels/base-channel-serializer';
export default BaseChannelSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    integrationMetas: {
      embedded: 'always'
    }
  },
  modelNameFromPayloadKey() {
    return 'channels/integration';
  }
});